// @ts-nocheck
import { __awaiter } from "tslib";
import { getOrLoadRemote } from './getOrLoadRemote';
export const loadComponent = (remote, sharedScope, module, url) => __awaiter(void 0, void 0, void 0, function* () {
    yield getOrLoadRemote(remote, sharedScope, url);
    const container = window[remote];
    const factory = yield container.get(module);
    const Module = factory();
    return Module;
});
